export function useFeatures(options?: { all?: boolean }) {
  const { $unleash } = useNuxtApp()

  return computed(() => {
    let features = Object.values($unleash.features)

    if (!options?.all) features = features.filter(({ isEnabled }) => isEnabled)

    return features
      .toSorted((a, b) => a.name.localeCompare(b.name))
      .map(({ name }) => toReactive(useFeature(name)))
  })
}
